import { V2ApiError } from '../services/v2';

export const asV2Error = (error: any) => error instanceof V2ApiError
    ? error
    : new V2ApiError((error && error.message) || '请求失败');

export type DateTimeValue = string | number | number[];

const parseDateTime = (value: string | number) => {
    if (typeof value === 'number' || /^\d+$/.test(String(value).trim())) {
        const numeric = Number(value);
        return new Date(numeric < 1_000_000_000_000 ? numeric * 1000 : numeric);
    }
    const text = String(value).trim();
    const direct = new Date(text);
    return Number.isNaN(direct.getTime()) ? new Date(text.replace(' ', 'T')) : direct;
};

const parseDateTimeArray = (value: number[]) => {
    if (value.length < 3) return null;
    const [year, month, day, hour = 0, minute = 0, second = 0] = value.map(Number);
    const parts = [year, month, day, hour, minute, second];
    if (!parts.every(Number.isFinite)
        || month < 1 || month > 12
        || day < 1 || day > 31
        || hour < 0 || hour > 23
        || minute < 0 || minute > 59
        || second < 0 || second > 59) {
        return null;
    }
    return { year, month, day, hour, minute, second };
};

export const formatDateTime = (value?: DateTimeValue | null) => {
    if (!value) return '—';
    const pad = (part: number) => String(part).padStart(2, '0');
    if (Array.isArray(value)) {
        const parts = parseDateTimeArray(value);
        if (!parts) return value.join(',');
        return `${parts.year}-${pad(parts.month)}-${pad(parts.day)} ${pad(parts.hour)}:${pad(parts.minute)}:${pad(parts.second)}`;
    }
    const date = parseDateTime(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const formatDate = (value?: DateTimeValue | null) => {
    if (!value) return '—';
    const pad = (part: number) => String(part).padStart(2, '0');
    if (Array.isArray(value)) {
        const parts = parseDateTimeArray(value);
        if (!parts) return value.join(',');
        return `${parts.year}-${pad(parts.month)}-${pad(parts.day)}`;
    }
    const date = parseDateTime(value);
    if (Number.isNaN(date.getTime())) return String(value);
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`;
};

export const formatMoney = (amount?: string | number | null, currency = 'CNY') => {
    if (amount === undefined || amount === null || amount === '') return '—';
    const value = Number(amount);
    if (!Number.isFinite(value)) return `${currency} ${amount}`;
    return `${currency} ${value.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
};

export const currentAdminId = () => {
    try {
        const raw = localStorage.getItem('CRM_WEB_user');
        const user = raw ? JSON.parse(raw) : null;
        return Number(user && (user.id || user.loginId)) || undefined;
    } catch (_) {
        return undefined;
    }
};
